import type { PlacePhoto } from '../types/place'

const pngByFile = import.meta.glob('../../palac-marianny/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>

function urlForFile(file: string): string | null {
  const entry = Object.entries(pngByFile).find(([key]) => key.replace(/\\/g, '/').endsWith(`/${file}`))
  return entry?.[1] ?? null
}

const PHOTOS: { file: string; alt: string }[] = [
  {
    file: 'palac-marianny-dron.png',
    alt: 'Pałac Marianny Orańskiej w Kamieńcu Ząbkowickim – widok z lotu ptaka na neogotycką bryłę i tarasy',
  },
  {
    file: 'palac-marianny-zdjecie-z-gory.png',
    alt: 'Pałac Marianny Orańskiej w Kamieńcu Ząbkowickim – panorama pałacu i ogrodów z wzniesienia',
  },
]

function photosFromEntries(entries: { file: string; alt: string }[]): PlacePhoto[] {
  return entries.flatMap((p) => {
    const src = urlForFile(p.file)
    if (!src) return []
    return [{ src, alt: p.alt }]
  })
}

export const palacMariannyPhotos: PlacePhoto[] = photosFromEntries(PHOTOS)

/** Obraz wyróżniający artykułu i meta OG (widok z drona). */
export const palacMariannyFeaturedPhoto: PlacePhoto | undefined = palacMariannyPhotos[0]
